// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./virtual.d.ts" />
import {
  manifest,
  loaders,
  validationLoaders
} from 'virtual:@rhino-project/core/translations';
import { translations, getLocale, onLocaleSelected } from '../i18n';
import { getLocaleCookieName } from './cookie';
import { localeWithTimeZone } from './selection';

const syncDocument = () => {
  const locale = getLocale();
  document.documentElement.lang = locale.replaceAll('_', '-');
  const intlLocale = new Intl.Locale(
    locale.replaceAll('_', '-')
  ) as Intl.Locale & {
    getTextInfo?: () => { direction: string };
    textInfo?: { direction: string };
  };
  document.documentElement.dir =
    intlLocale.getTextInfo?.().direction ??
    intlLocale.textInfo?.direction ??
    (/^(ar|dv|fa|he|ps|ur|yi)(-|$)/.test(locale) ? 'rtl' : 'ltr');
};
const unsubscribe = translations.subscribe(syncDocument);
const unsubscribeSelection = onLocaleSelected((locale) => {
  document.cookie = `${getLocaleCookieName()}=${encodeURIComponent(locale)}; Path=/; SameSite=Lax; Max-Age=31536000`;
});
const localeTag = document.querySelector<HTMLMetaElement>(
  'meta[name="rhino-locale"]'
);
let initialLocale = localeTag?.content;
if (initialLocale && localeTag?.dataset.source === 'automatic') {
  let timeZone: string | undefined;
  try {
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    // Restricted or unavailable device settings leave Rails' language intact.
  }
  initialLocale = localeWithTimeZone(
    initialLocale,
    manifest.selectableLocales ?? manifest.locales,
    manifest.timeZoneRegions,
    timeZone
  );
}

export const translationsReady = translations.configure(
  manifest,
  loaders,
  initialLocale,
  validationLoaders
);

if (import.meta.hot) {
  import.meta.hot.accept(
    'virtual:@rhino-project/core/translations',
    async (next) => {
      if (next)
        await translations.configure(
          next.manifest,
          next.loaders,
          getLocale(),
          next.validationLoaders
        );
    }
  );
  import.meta.hot.dispose(() => {
    unsubscribe();
    unsubscribeSelection();
  });
}
